import { getStyle } from "../../../../hooks/use-styles";
import ResizeWrapper from "../../../../components/ResizeWrapper";

const LabelItem = ({ title, subTitle }) => {
  return (
    <ResizeWrapper
      render={(resizeWidth) => (
        <div>
          <div
            className={`${
              resizeWidth > 375
                ? "font-14-normal-400-lh-18"
                : "font-12-normal-400-lh-20"
            }`}
            style={{ color: getStyle("secondaryGray") }}
          >
            {title}
          </div>
          <div
            className={`${
              resizeWidth > 375
                ? "font-18-regular-500-lh-22"
                : "font-14-bold-500-lh-20"
            }`}
            style={{ color: getStyle("black") }}
          >
            {subTitle}
          </div>
        </div>
      )}
    />
  );
};

export default LabelItem;
